import {
   ChangeDetectionStrategy,
   Component,
   EventEmitter,
   Input,
   Output,
   ViewChild,
   ViewEncapsulation,
} from '@angular/core';
import { TileTypes } from 'generated/graphql-types';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-tile-card-view',
    templateUrl: './tile-card-view.component.html',
    styleUrls: ['./tile-card-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TileCardViewComponent {
   @ViewChild('topRightOverride') topRightOverride;

   @Input() disabled: boolean = false;

   @Input() description: string | null;

   @Input() designerDescription: string | null = null;

   @Input() types: TileTypes[] | null;

   @Input() showTypeInTitle: boolean = false;

   @Output() addTile = new EventEmitter<void>();

   @Output() cardClick = new EventEmitter<void>();

   get displayTypes(): string[] | null {
      return this.types?.map((v) => this.getTileType(v)) ?? null;
   }

   onAddTile(): void {
      this.addTile.emit();
   }

   onTileCardClick() {
      this.cardClick.emit();
   }

   private getTileType(value: TileTypes): string {
      switch (value) {
         case TileTypes.Summary:
            return 'Summary';
         case TileTypes.Table:
            return 'Table';
         case TileTypes.BarGraph:
            return 'Bar Graph';
         case TileTypes.LineGraph:
            return 'Line Graph';
         case TileTypes.PieGraph:
            return 'Pie Graph';
         case TileTypes.Clock:
            return 'Clock';
         case TileTypes.PieGridGraph:
            return 'Pie Grid Graph';
         default:
            return '';
      }
   }
}
